export default () => {
  if (process.env.NODE_ENV === "development") {
    return location.hostname
  }
  const parts = location.hostname.split(".")
  return parts.slice(-2).join(".")
}
